import { conditionConstants } from '../constants';
import { prefixId } from '../fieldId';
var separators = [conditionConstants.quote].concat(conditionConstants.operators);
var PRECEDENCE = {
  HIGHER_PRIORITY: 0,
  LOWER_PRIORITY: 1,
  UNDETERMINED: -1
};

var getOperator = function getOperator() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return separators.reduce(function (startingSeparator, currentSeparator) {
    if (text.startsWith(currentSeparator)) {
      if (!startingSeparator || currentSeparator.length > startingSeparator.length) {
        return currentSeparator;
      }
    }

    return startingSeparator;
  }, '');
};

var getParentheses = function getParentheses() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return conditionConstants.parentheses.map(function (p) {
    return p[0];
  }).reduce(function (startingParentheses, currentParentheses) {
    if (startingParentheses) return startingParentheses;

    if (text.startsWith(currentParentheses)) {
      return currentParentheses;
    }

    return startingParentheses;
  }, '');
};

var isOpeningParentheses = function isOpeningParentheses(paren) {
  return conditionConstants.openingParentheses.includes(paren);
};

var getFieldId = function getFieldId() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var match = text.match(/^\d+/);
  return match && match[0];
};

var getQuotedValue = function getQuotedValue() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var index = text.substr(1).indexOf(conditionConstants.quote);
  return text.substr(1, index);
};

var comparePrecedence = function comparePrecedence(separator1, separator2) {
  var i1 = separators.indexOf(separator1);
  var i2 = separators.indexOf(separator2);
  if (i1 === -1 || i2 === -1) return PRECEDENCE.UNDETERMINED;
  if (i1 < i2) return PRECEDENCE.HIGHER_PRIORITY;
  return PRECEDENCE.LOWER_PRIORITY;
};

var infixToPostfixNotation = function infixToPostfixNotation() {
  var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var stack = [];
  var postfixNotation = [];
  var currentCondition = condition.trim();
  var removeCount = 0;

  while (currentCondition) {
    var separator = getOperator(currentCondition);

    if (separator === conditionConstants.quote) {
      var value = getQuotedValue(currentCondition);
      removeCount = value && value.length + 2 || 0;
      postfixNotation.push(value);
    } else if (separator) {
      if (stack.length) {
        var lastStackedIsOpenParentheses = isOpeningParentheses(stack[stack.length - 1]);
        var comparisonResult = comparePrecedence(separator, stack[stack.length - 1]);

        if (comparisonResult === PRECEDENCE.HIGHER_PRIORITY || lastStackedIsOpenParentheses) {
          stack.push(separator);
          removeCount = separator.length;
        } else if (comparisonResult === PRECEDENCE.LOWER_PRIORITY) {
          while (comparisonResult === PRECEDENCE.LOWER_PRIORITY) {
            postfixNotation.push(stack.pop());
            comparisonResult = comparePrecedence(separator, stack[stack.length - 1]);
          }

          stack.push(separator);
          removeCount = separator.length;
        } else {
          throw new Error('Unknown precedence for', separator);
        }
      } else {
        stack.push(separator);
        removeCount = separator.length;
      }
    } else {
      var parentheses = getParentheses(currentCondition);

      if (parentheses) {
        if (isOpeningParentheses(parentheses)) {
          stack.push(parentheses);
          removeCount = parentheses.length;
        } else {
          var matchingOpenParentheses = conditionConstants.closeToOpenParenthesesMap[parentheses];
          var temp = stack.pop();

          while (temp !== matchingOpenParentheses && stack.length) {
            postfixNotation.push(temp);
            temp = stack.pop();
          }

          removeCount = parentheses.length;
        }
      } else {
        var id = getFieldId(currentCondition);
        postfixNotation.push(prefixId(id));
        removeCount = "".concat(id).length;
      }
    }

    currentCondition = currentCondition.substr(removeCount).trim();
  }

  while (stack.length) {
    postfixNotation.push(stack.pop());
  }

  return postfixNotation;
};

export default infixToPostfixNotation;